module.exports = __webpack_public_path__ + "vote.35b83d43.png";